import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const pop = {
  getShopIndexInfo: data =>
    mallEntranceApi.post(apiPath.getShopIndexInfo, data),
  getPopSaleClassify: data =>
    mallEntranceApi.post(apiPath.getPopSaleClassify, data),
  getPopSkuSsuBySaleClass2Id: data =>
    mallEntranceApi.post(apiPath.getPopSkuSsuBySaleClass2Id, data),
  getPopQualificationPic: data =>
    mallEntranceApi.post(apiPath.getPopQualificationPic, data),
  getPopQualificationInfo: data =>
    mallEntranceApi.post(apiPath.getPopQualificationInfo, data)
}
